import * as z from "zod";
import {
  FlowContentNodeSchema,
  type FlowContentNode,
} from "./flow-content-node-schema";

/**
 * Paragraph node containing inline content.
 */
const ParagraphNodeSchema_ = z.object({
  type: z.literal("paragraph"),
  content: z.array(FlowContentNodeSchema).optional(),
});

/** Base type from schema inference (no index signature) */
type ParagraphNodeBase = Omit<
  z.infer<typeof ParagraphNodeSchema_>,
  "content"
> & { content?: FlowContentNode[] };

/** Full type with index signature for FlowContentNode compatibility */
export type ParagraphNode = ParagraphNodeBase & { [key: string]: unknown };

export const ParagraphNodeSchema: z.ZodType<ParagraphNode> =
  ParagraphNodeSchema_;
